import i18n from "../../../../i18n"

const QuantityInput = ({ 
    value, 
    onChange, 
    min = 0, 
    max = null, 
    disabled = false,
    name,
    dataId,
    onMaxReached = null
}) => {
    const handleDecrease = () => {
        const newValue = value === 0 ? 0 : value - 1
        onChange(newValue)
    }

    const handleIncrease = () => {
        if (max !== null && value >= max) {
            if (onMaxReached) {
                onMaxReached()
            }
            return
        }
        onChange(value + 1)
    }

    const handleChange = (e) => {
        const val = parseInt(e.target.value) || 0
        if (max !== null && val >= max) {
            onChange(max)
            if (onMaxReached) {
                onMaxReached()
            }
        } else {
            onChange(val < min ? min : val)
        }
    }

    return (
        <div className="btn-group" role="group" aria-label="Small button group">
            <div 
                className="py-1 btn btn-outline-light text-dark d-flex justify-content-center align-items-center" 
                onClick={handleDecrease}
                type="button"
                disabled={disabled || value === 0}
            > 
                - 
            </div>
            <input 
                data-id={dataId}
                name={name}
                type="text" 
                min={min}
                disabled={disabled}
                className="btn btn-quantity btn-outline-light form-control text-dark pe-0"  
                onChange={handleChange}
                value={value} 
            />
            <div
                className="py-1 btn btn-outline-light text-dark d-flex justify-content-center align-items-center" 
                type="button" 
                disabled={disabled || (max !== null && value >= max)}
                onClick={handleIncrease}
            > 
                + 
            </div>
        </div>
    )
}

export default QuantityInput






















